/**
 * @readonly
 * @enum {string}
 */
export const TpmsTireLocations = Object.freeze({
    L1: 'L1', // Left outer wheel
    L2: 'L2', // Left inner wheel 1
    L3: 'L3', // Left inner wheel 2
    L4: 'L4', // Left inner wheel 3
    ST: 'ST', // Spare tire
    R1: 'R1', // Right outer wheel
    R2: 'R2', // Right inner wheel 1
    R3: 'R3', // Right inner wheel 2
    R4: 'R4' //  Right inner wheel 3
})
